const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const CONSENT_KEY = "mea_consent_analytics";

let initialized = false;
let lastPath = null;
let pendingPath = null;

export function getConsent() {
  if (typeof window === "undefined") return null;
  const v = localStorage.getItem(CONSENT_KEY);
  return v === "granted" ? "granted" : v === "denied" ? "denied" : null;
}

export function setConsent(value) {
  localStorage.setItem(CONSENT_KEY, value);
  if (value === "granted") {
    initAnalytics();
    if (pendingPath) {
      const p = pendingPath;
      pendingPath = null;
      trackPageView(p);
    }
  }
}

export function initAnalytics() {
  if (initialized || !GA_ID || typeof window === "undefined") return;
  if (getConsent() !== "granted") return; // aucune mesure sans consentement
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // Les pages vues sont envoyées manuellement à chaque changement de route (SPA)
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

function ready() {
  return GA_ID && typeof window !== "undefined" && getConsent() === "granted" && window.gtag;
}

export function trackEvent(name, params = {}) {
  if (!ready()) return;
  window.gtag("event", name, params);
}

export function trackPageView(path, title) {
  if (!ready()) {
    pendingPath = path;
    return;
  }
  if (path === lastPath) return; // évite le doublon au montage (StrictMode)
  lastPath = path;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
  });
}
